// extracted by mini-css-extract-plugin
var _1 = "SettingsImageEditor-module__container--BQjr4";
var _2 = "SettingsImageEditor-module__input--Cuhcf";
export { _1 as "container", _2 as "input" }
